// INDEX
export const ROOT = '';
export const INDEX = '/';
export const REGISTRATION = '/registration';
export const LOGIN = '/login';
export const CODE = '/code';
export const DONE = '/done';
export const PAYMENT = '/payment';
export const PAYMENT_UPDATE = '/payment/update/:UID';
export const DOC_POLICY_EN = '/docs/policy_en.pdf';
export const DOC_POLICY_ES = '/docs/policy_es.pdf';
export const DOC_OFFER_EN = '/docs/offer_en.pdf';
export const DOC_OFFER_ES = '/docs/offer_es.pdf';
